const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        <p>Aaron Buachie 2021</p>
        <a href="https://abuachie.com">abuachie.com</a>
      </div>
    </footer>
  );
};

export default Footer;
